/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/resebyran/"

const resebyran: CommunityData = {
  code: "resebyran",
  inviteCode: "resebyran",
  name: "Resebyrån",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/res-080`,
  defaultCurrency: "SEK",
  socials: {},
  styles: {
    global: {
      werzLogoColor: "#FFF",
      counterColor: "#FFF",
      logo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[34px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[128px] h-[128px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border-r border-[#333333]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['SpecialEliteRegular']",
      primaryButton:
        "bg-[#ffffff] border border-[#ffffff] px-[18px] py-[18px] !text-[#000000] font-['AnarchyRegular'] !text-[22px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#444444]",
      separator: "border-[#444444]",
      item: "font-['SpecialEliteRegular'] text-[16px] text-[#ffffff] text-left leading-[120%] gap-x-[10px] text-opacity-50 text-center border-b border-[#444444] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] border border-[#6d6d6d] !pb-8",
      titles: "text-[#ffffff] font-['AnarchyRegular'] text-[40px] text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['SpecialEliteRegular'] text-[14px] text-left leading-[130%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#6d6d6d]",
        sectionTitle:
          "text-[#ffffff] font-['AnarchyRegular'] text-[40px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#ffffff] font-['SpecialEliteRegular'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#ffffff] font-['SpecialEliteRegular'] text-[14px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#6d6d6d]",
        sectionTitle:
          "text-[#ffffff] font-['AnarchyRegular'] text-[40px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#ffffff] font-['SpecialEliteRegular'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#ffffff] font-['SpecialEliteRegular'] text-[12px] text-left leading-[130%] mt-2",
          location:
            "text-[#ffffff] font-['SpecialEliteRegular'] text-[12px] text-left leading-[130%] mt-1",
          date: "text-[#ffffff] font-['SpecialEliteRegular'] text-[12px] text-left leading-[130%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ffffff] font-['SpecialEliteRegular'] text-[22px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['SpecialEliteRegular'] text-[16px] text-left leading-[130%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['AnarchyRegular'] text-[40px] text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] border border-[#6d6d6d] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#6d6d6d]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#ffffff] font-['SpecialEliteRegular'] text-[26px] text-left leading-[110%]",
        subtitle:
          "text-[#ffffff] font-['SpecialEliteRegular'] text-[14px] text-left leading-[130%] mb-4 mt-2",
        button:
          "bg-[#ffffff] border border-[#ffffff] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['AnarchyRegular'] !text-[22px] text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[130%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#6d6d6d]",
        header: "text-[#ffffff] font-['SpecialEliteRegular'] text-[22px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['SpecialEliteRegular'] text-[14px] text-left leading-[130%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#6d6d6d]",
        header: "text-[#ffffff] font-['SpecialEliteRegular'] text-[22px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['SpecialEliteRegular'] text-[14px] text-left leading-[130%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#ffffff",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#ffffff] font-['SpecialEliteRegular'] text-[22px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['SpecialEliteRegular'] text-[14px] text-left leading-[130%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['SpecialEliteRegular'] text-[22px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-4 sm:mb-6 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['AnarchyRegular'] text-[16px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#6d6d6d] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['SpecialEliteRegular'] text-[16px] text-left leading-[110%] mb-1",
          description:
            "text-[#ffffff] font-['SpecialEliteRegular'] text-[14px] text-left leading-[130%] mb-1 flex flex-row",
          price: "text-[#ffffff] font-['SpecialEliteRegular'] text-[16px] text-left leading-[110%]",
          quantity: "text-[#ffffff] font-['AnarchyRegular'] text-[16px] text-left leading-[100%]",
          status:
            "text-[#ffffff] font-['SpecialEliteRegular'] text-[16px] text-left leading-[110%]",
          counterContainer:
            "bg-[#000000] border border-[#ffffff] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#000000] border border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['AnarchyRegular'] text-[16px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default resebyran
